// extracted by mini-css-extract-plugin
module.exports = {"signInButton":"styles_signInButton__2SRvm"};